import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Edit,
  TextInput,
  SimpleForm,
  SelectInput,
  Create,
} from 'react-admin';
import Icon from '@material-ui/icons/ListAlt';
import {ColoredChipField, colorStyles} from "../utils";

export const CompanyMilestoneIcon = Icon;

export const CompanyMilestoneList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="key_name"/>
      <TextField source="name"/>
      <ColoredChipField source="color"/>
    </Datagrid>
  </List>
);

export const CompanyMilestoneEdit = props => (
  <Edit undoable={false} {...props}>
    <SimpleForm>
      <TextInput source="name"/>
      <TextInput source="key_name"/>
      <SelectInput source="color" choices={Object.keys(colorStyles).map(v => ({id: v, name: v}))} allowEmpty alwaysOn/>
    </SimpleForm>
  </Edit>
);

export const CompanyMilestoneCreate = props => (
  <Create undoable={false} {...props}>
    <SimpleForm defaultValue={{resource: 'companies'}}>
      <TextInput source="name"/>
      <TextInput source="key_name"/>
      <SelectInput source="color" choices={Object.keys(colorStyles).map(v => ({id: v, name: v}))} allowEmpty alwaysOn/>
    </SimpleForm>
  </Create>
);
